<template>
  <div>
    <div class="banner">
      <div class="titleSub">Multi format solutions</div>
      <div class="title wow animate__animated durationTime animate__fadeInUp">
        多业态解决方案
      </div>
      <div class="desc wow animate__animated durationTime animate__fadeInUp">
        专注智慧园区场景，持续助力学校和工厂数字化转型升级
      </div>
    </div>
    <div class="solution">
      <div class="solution-con">
        <div
          class="first-title wow animate__animated durationTime animate__fadeInUp"
          style="margin-top: 0"
        >
          无线网络解决方案
        </div>
        <div class="solution-one solution-box"  style="margin-bottom: 1.2rem">
          <div
            class="solution-one-item wow animate__animated durationTime animate__fadeInUp"
            v-for="(item, index) in solutions"
            v-if="solutions && solutions.length"
            :key="`for-solution` + index"
            :style="{
              backgroundColor:'#ccc',
              backgroundImage: `url(${require(`@/assets/${item.imageSrc}`)})`
            }"
          >
            <div class="introduce">
              <div class="title">{{ item.name }}</div>
              <div class="desc">{{ item.desc }}</div>
            </div>
            <div class="solution-more">
              <div class="con">
                <div>方案详情</div>
                <img src="../../assets/image/solution/solution-more.png" />
              </div>
            </div>
            <div v-if="item.name=='中职'" class="solution-detail" style="padding-top: 0.7rem">
              <img  src="../../assets/image/solution/solution-detail-bg.png" style=" width: 100%; height: 100%;">
              <div class="box" style="">
                <div style="display: flex;justify-content: space-around;}">
                  <div class="tag" @click="detail(0)"> 运营托管模式解决方案</div>
                  <div class="tag"  @click="detail(1)">自运营模式解决方案</div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
<!--      <div class="solution-con">-->
<!--        <div class="first-title wow animate__animated durationTime animate__fadeInUp">-->
<!--          智慧校园解决方案-->
<!--        </div>-->
<!--        <div-->
<!--          class="solution-two solution-box wow animate__animated durationTime animate__fadeInUp"-->
<!--        >-->
<!--          <div class="title ">校园一卡通</div>-->
<!--          <div class="desc">-->
<!--            我们已成功为多所知名中职学校部署了高效稳定的无线网络环境，并与教育行业的多个重要合作伙伴建立了长期合作关系，共同推动教育信息化发展。-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--      <div class="solution-con">-->
<!--        <div class="first-title wow animate__animated durationTime animate__fadeInUp">-->
<!--          智慧园区解决方案-->
<!--        </div>-->
<!--        <div class="solution-three wow animate__animated durationTime animate__fadeInUp">-->
<!--          <div class="title">智慧工业园区</div>-->
<!--          <div class="desc">网联数智平台，打破“烟囱”，实现园区整体智慧化。</div>-->
<!--        </div>-->
<!--      </div>-->
      <div class="solution-con solution-four">
        <div class="first-title wow animate__animated durationTime animate__fadeInUp">
          智慧园区解决方案
        </div>
        <div class="solution-four-box">
          <img class="wow animate__animated durationTime animate__fadeInUp" src="../../assets/image/solution/solution-smart-school1.png">
          <div class="right">
            <div class="one wow animate__animated durationTime animate__fadeInUp">校园一卡通</div>
            <div class="two wow animate__animated durationTime animate__fadeInUp" style="line-height: 0.4rem;width: 5.68rem">我们已成功为多所知名中职学校部署了高效稳定的无线网络环境，并与教育行业的多个重要合作伙伴建立了长期合作关系，共同推动教育信息化发展。</div>
            <div class="three wow animate__animated durationTime animate__fadeInUp background-fill">查看详情</div>
          </div>
        </div>
      </div>
      <div class="solution-con solution-four">
        <div class="first-title wow animate__animated durationTime animate__fadeInUp">
          智慧园区解决方案
        </div>
        <div class="solution-four-box">
          <img class="wow animate__animated durationTime animate__fadeInUp" src="../../assets/image/solution/solution-smart-factory1.png">
          <div class="right">
            <div class="one wow animate__animated durationTime animate__fadeInUp">智慧工业园区</div>
            <div class="two wow animate__animated durationTime animate__fadeInUp">网联数智平台，打破“烟囱”，实现园区整体智慧化。</div>
            <div class="three wow animate__animated durationTime animate__fadeInUp background-fill">查看详情</div>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import { WOW } from "wowjs";
import solutionsData from "./solutionsData";
export default {
  name: "index",
  data() {
    return {
      solutions: [],
      imageSrc:'image/solution/solution-wx-zz.png'
    };
  },
  created() {
    this.solutions = solutionsData;
  },
  methods:{
    detail(index){
      console.log(index)
      this.$router.push({
        name: "solutionDetail",
        query: {
          id: index
        }
      });
    }
  },
  mounted() {
    // init wow
    const wow = new WOW({
      boxClass: "wow", //需要执行动画元素的Class
      animateClass: "animated_lightSpeedIn", //animation.css动画的Class
      offset: 0, //距离可视区域多少开始执行动画
      mobile: true, //是否在移动设备执行动画
      live: true //异步加载的内容是否有效
    });
    wow.init();
  }
};
</script>

<style scoped lang="scss">
.banner {
  width: 100%;
  height: 5.8rem;
  background: url("../../assets/image/solution/solution-bg.png") center
    no-repeat;
  background-size: cover;

  .title {
    font-size: 0.44rem;
    font-weight: 500;
    text-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
    margin-top: 2.25rem;
    margin-left: 2.18rem;
    position: relative;
    color: #fff;
    display: inline-block;
  }

  .titleSub {
    content: "";
    position: absolute;
    margin-top: 1.94rem;
    margin-left: 2.18rem;
    font-size: 0.44rem;
    font-weight: 500;
    color: rgb(169 160 160 / 51%);
    text-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
    letter-spacing: 0.02rem;
  }

  .desc {
    font-weight: 400;
    font-size: 0.24rem;
    color: #ffffff;
    margin-top: 0.2rem;
    margin-left: 2.18rem;
  }
}
.solution {
  padding: 1rem 2.18rem;
  .solution-con:last-child {
    border-bottom: none !important;
    padding-bottom: 0;
  }
  .solution-con {
    border-bottom: 0.02rem solid #e6e6e6;
    padding-bottom: 0.4rem;
    .first-title {
      margin: 0.4rem 0;
      font-weight: 500;
      font-size: 0.32rem;
      color: #333333;
    }

    .solution-one {
      display: flex;
      //flex-wrap: wrap;
      //align-items: center;
      justify-content: space-between;
      .solution-one-item {
        height: 4.18rem;
        cursor: pointer;
        background-position: center;
        background-repeat: no-repeat;
        background-size: cover;
        &:hover {

          .solution-detail{
            visibility: visible;
          }
          .solution-more {
            display: block;
            animation: fadeIn 0.7s forwards;
            opacity: 0;
          }
          .desc {
            animation: fadeOut 0.7s forwards;
            opacity: 1;
          }
          margin-top: -0.14rem;
          transition: margin-top 0.5s; /* 使用transition定义margin-top变化过渡效果 */
        }
        position: relative;
        //background: url("../../assets/image/solution/solution-wx-zz.png") center no-repeat;
        //background-size: cover;
        width: calc((100% - 0.6rem) / 4);
        padding: 2.45rem 0.4rem 0.4rem 0.4rem;
        .solution-more {
          .con {
            display: flex;
            justify-content: space-between;
            align-items: center;
            img {
              width: 0.26rem;
              position: relative;
              animation: moveIcon 1.5s linear infinite alternate; /* 左右循环移动动画 */
            }
            div {
              font-weight: 500;
              font-size: 0.16rem;
              color: #333333;
            }
          }
          position: absolute;
          padding: 0.29rem 0.4rem;
          background-color: #fef100;
          width: 100%;
          left: 0;
          bottom: 0;
          display: none;
        }
        .title {
          font-weight: 500;
          font-size: 0.24rem;
          color: #ffffff;
          margin-bottom: 0.2rem;
        }
        .desc {
          font-weight: 400;
          font-size: 0.14rem;
          color: #ffffff;
          height: 0.8rem;
          text-indent: 2em;
        }
      }
    }
    .solution-detail{
      width: 6.17rem;
      margin-left:-0.4rem;
      visibility: hidden;
      position: relative;
      .box{
        justify-content:space-around;
        align-items: center;
        width: 100%;
        position: absolute;
        top: 70%;
        left: 50%;
        transform: translate(-50%, -50%);
        .tag{
          font-weight: 500;
          font-size: 0.24rem;
          color: #FFFFFF;
          cursor: pointer;
          &:hover{
            color: #FEF100;
          }
        }
      }
    }
    .solution-two {
      cursor: pointer;
      background: url("../../assets/image/solution/solution-smart-school.png")
        center no-repeat;
      background-size: cover;
      padding: 3.05rem 0rem 0.4rem 0.4rem;
      .title {
        font-weight: 500;
        font-size: 0.24rem;
        color: #ffffff;
        margin-bottom: 0.2rem;
      }
      .desc {
        font-weight: 400;
        font-size: 0.14rem;
        color: #ffffff;
      }
    }
    .solution-three {
      cursor: pointer;
      background: url("../../assets/image/solution/solution-smart-fatory.png")
        center no-repeat;
      background-size: cover;
      padding: 3.05rem 0rem 0.4rem 0.4rem;
      .title {
        font-weight: 500;
        font-size: 0.24rem;
        color: #ffffff;
        margin-bottom: 0.2rem;
      }
      .desc {
        font-weight: 400;
        font-size: 0.14rem;
        color: #ffffff;
      }
    }
    .solution-four-box{
      display: flex;
      img{
        width: 7.22rem;
        margin-right: 1rem;
      }
      .right{
        display: flex;
        flex-direction: column;
        justify-content:center;
        .one{
          margin-bottom: 0.4rem;
          font-weight: 500;
          font-size: 0.24rem;
          color: #333333;
        }
        .two{
          margin-bottom: 0.4rem;
          font-weight: 400;
          font-size: 0.14rem;
          color: #333333;
        }
        .three{
          background: url("../../assets/image/solution/solution-four-more.png") center
          no-repeat;
          background-size: cover;
          width: 1.4rem;
          height: 0.42rem;
          display: flex;
          justify-content: center;
          align-items: center;
          font-weight: 400;
          font-size: 0.16rem;
          color: #333333;
          cursor: pointer;
          //&:hover{
          //  background-image: url("../../assets/image/solution/solution-four-more-hover.png");
          //  background-position: center bottom;
          //  background-repeat: no-repeat;
          //  background-size: cover;
          //  transition: background-position 2s;
          //}
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/solution/index.vue